<!--
 * @Author: Latte
 * @Date: 2021-12-07 16:01:47
 * @LAstEditors: Latte
 * @LastEditTime: 2022-06-29 15:55:07
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\FileManagement\File\ConditionDetail.vue
-->
<template>
  <div class="app-container">
    <div class="topbar">
      <div><h3>当前分类：{{this.currentConditionName}}</h3></div>
      <div>
        <el-button size="small" type="primary" @click.stop="goBack()">返 回</el-button>
        <el-button
          type="primary"
          size="small"
          @click.stop="handleCreateCondition(id, 1)"
        >
          新增属性
        </el-button>
      </div>
    </div>

    <!--分类属性列表-->
    <el-table
      :data="tableData"
      v-loading="loading"
      :header-cell-style="{ background: '#F5F7FA' }"
      style="width: 100%; margin-bottom: 20px"
      border
    >
      <el-table-column
              label="排序"
              align="center"
              prop="sort"
              width="60"
      ></el-table-column>
      <el-table-column
              label="属性"
              align="center"
              width="150"
      >
        <template slot-scope="scope">
          {{getPropertyName(scope.row.fieldName)}}
        </template>
      </el-table-column>
      <el-table-column
        label="属性别名（自定义）"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <el-tag size="medium">{{scope.row.showName}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="属性值" align="center">
        <template slot-scope="scope">
          <el-tag
            style="margin-right: 10px;margin-top: 5px"
            v-for="(item,index) in scope.row.childConditionList"
            :key="item.csFileConditionID"
            v-show="index <= numFlag"
            type="info"
            size="small"
            >{{ item.showName }}</el-tag>
            <el-tag v-if="scope.row.childConditionList!==null && scope.row.childConditionList.length > numFlag+1" type="info">
              +{{scope.row.childConditionList.length - numFlag}}
            </el-tag>
          <i @click="handleSetParam(scope.row)" class="el-icon-setting" style="float: right;font-size: 23px; "></i>
        </template>
      </el-table-column>
<!--      <el-table-column label="参数配置" align="center" width="120">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button size="small" @click="handleSetParam(scope.row)"-->
<!--            >详细配置</el-button-->
<!--          >-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="启用为筛选条件" align="center"   width="120">
        <template slot-scope="scope">
          <el-switch
                  active-color="#03be56"
                  @change="toggleShowStatus(scope.row)"
                  :active-value="true"
                  :inactive-value="false"
                  v-model="scope.row.isEnable"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            @click.stop="handleUpdateCondition(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            size="small"
            @click.stop="handleRemoveProp(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 参数列表对话框 -->
    <el-dialog title="属性值配置" :visible.sync="paramDialogVisible" width="50%"  :before-close="handleParamDialogClose">
      <h3 style="margin-top: -20px">属性名称：<el-tag size="medium">{{this.currentPropertyName}}</el-tag></h3>
      <el-button
              icon="el-icon-plus"
              type="primary"
              size="small"
              style="float:right"
              @click.stop="handleCreateValue(parentID,parentFieldName, 2)"
      >
        新增属性值
      </el-button>
      <el-table :data="paramsList" max-height="450px">
        <el-table-column
                label="ID"
                align="center"
                prop="fieldValue"
                width="80"
        ></el-table-column>
        <el-table-column
                label="属性值"
                align="center"
                prop="showName"
        ><template slot-scope="scope"><el-tag size="medium" type="info">{{scope.row.showName}}</el-tag></template></el-table-column>
        <el-table-column label="启用为筛选条件" align="center">
          <template slot-scope="scope">
            <el-switch
                    active-color="#03be56"
                    @change="toggleShowStatus(scope.row)"
                    :active-value="true"
                    :inactive-value="false"
                    v-model="scope.row.isEnable"
            >
            </el-switch
            ></template>
        </el-table-column>
        <el-table-column
                label="排序"
                align="center"
                prop="sort"
                width="50"
        ></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
                    type="primary"
                    size="small"
                    @click="handleUpdateParam(scope.row)"
            >编辑</el-button
            >
            <el-button
                    type="danger"
                    size="small"
                    @click="handleRemoveParam(scope.row)"
            >删除</el-button
            ></template
          >
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 属性：新增/编辑对话框 -->
    <el-dialog
            :title="conditionDialogLabel"
            :visible.sync="conditionDialogVisible"
            width="40%"
    >
      <el-form ref="formRef" :model="conditionModel" label-width="150px">
        <el-form-item label="请选择属性" prop="showName" :rules="required"  v-show="showProperty">
          <el-select
                  v-model="conditionModel.fieldName"
                  class="tag-select"
                  size="medium"
                  placeholder="请选择当前系统支持配置的属性"
                  @change="fillProName($event)"
                  style="width:80%"
          >
            <el-option
                    v-for="item of addPropertyList"
                    :key="item.typeName"
                    :value="item.typeName"
                    :label="item.name"
                    :disabled="disableType"
            >
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="属性别名" prop="showName" clearable :rules="required">
          <el-input
                  style="width:80%"
                  v-model="conditionModel.showName"
                  placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="俄语版名称" prop="showNameRussian">
          <el-input
                  style="width:80%"
                  v-model="conditionModel.showNameRussian"
                  placeholder="请输入俄语版名称"
          ></el-input>
          <div>俄语版本显示名,海外版必填</div>
        </el-form-item>
        <el-form-item label="启用为筛选条件" v-if="showSelectOpt" prop="enable">
          <el-radio-group v-model="conditionModel.isEnable">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number
                  size="small"
                  v-model="conditionModel.sort"
                  :min="1"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click.stop="conditionDialogVisible = false"
        >取 消</el-button
        >
        <el-button
                type="primary"
                size="small"
                @click.stop="
            conditionDialogStatus === 'createCondition'
              ? addCondition()
              : updateCondition()
          "
        >确 定</el-button>
      </div>
    </el-dialog>

    <!--参数值：新增/编辑对话框-->
    <el-dialog
            :title="conditionDialogLabel"
            :visible.sync="valueDialogVisible"
            width="45%"
    >
      <el-form ref="formRef" :model="conditionModel" label-width="150px">
        <div v-if="disableOption">
          <el-form-item label="属性值" prop="showName">
            <el-select
                    :disabled="!showParamSelect"
                    v-model="conditionModel.fieldValue"
                    class="tag-select"
                    size="medium"
                    placeholder="请从系统提供的数据中选择"
                    @change="fillValueName($event)"
                    style="width:60%"
            >
              <el-option
                      v-for="item of valueList"
                      :key="item.id"
                      :value="item.id"
                      :label="item.name"
              >
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="属性值名称" prop="showName" clearable>
          <el-input
                  style="width:60%"
                  v-model="conditionModel.showName"
                  placeholder="请输入"
          ></el-input>
        </el-form-item>
        <div v-if="disableValue&&showParamID">
          <el-form-item label="ID" prop="fieldValue" clearable>
            <el-input
                    style="width:60%"
                    v-model="conditionModel.fieldValue"
                    placeholder="请为属性值设置唯一ID"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="是否启用为筛选条件" v-if="showSelectOpt" prop="enable">
          <el-radio-group v-model="conditionModel.isEnable">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序序号">
          <el-input-number
                  size="small"
                  v-model="conditionModel.sort"
                  :min="1"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click.stop="valueDialogVisible = false"
        >取 消</el-button
        >
        <el-button
                type="primary"
                size="small"
                @click.stop="
            conditionDialogStatus === 'createParam'
              ? addCondition()
              : updateCondition()
          "
        >确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  addCondition,
  deleteCondition,
  updateCondition,
  getConditionDetail,
  getFileCategoryList,
  getMachineSeriesList,
} from "@/api/system/CSDocument/file";

const defaultModel = {
  showName: "",
  showNameRussian: "",
  sort: 1,
  fieldOp: "equal",
  type: 0,
};
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      numFlag:10,
      showParamSelect:true,
      showParamID:true,
      showProperty:true,
      currentPropertyName:"",
      showSelectOpt:true,
      fileCategoryList:[],
      machineSeriesList:[],
      valueList:[],
      disableOption:false,
      disableValue:false,

      disableType:false,
      maxsort:1,
      currentConditionName:"",
      csFileConditionID: '',
      loading: false,
      tableData: [],  //属性列表
      searchValue: "",
      conditionDialogStatus: "",
      valueDialogVisible:false,
      conditionDialogVisible: false,
      conditionModel: {
        showName: "",
        sort: '',
      },
      paramDialogVisible: false,
      paramsList: [], // 参数列表
      required: [{ required: true, message: "必填项", trigger: "blur" }], // 校验规则
      parentID: 0,
      parentFieldName:"",

      /**
       * fill  1 必填 2 非必填
       * type: 1 有表（无需自定义） 2 无表（需自定义） 3 填空
       * desc: 说明
       * disable:
       */
      addPropertyList:[
        {typeName:"csFileTypeID",name:"资料类型",desc:"如：宣传视频、产品简介资料",fill:"1",type:"1"},
        {typeName:"machineSeriesID",name:"适用机型",desc:"如：Apogee 1000",fill:"1",type:"1"},
        {typeName:"userDataType",name:"产品类型",fill:"1",desc:"如：医用、射线",type:"2",value:[{propName:"医用",value:"0"},{propName:"射线",value:"1"},{propName:"医用 & 射线",value:"2"}]},
        {typeName:"areaType",name:"应用领域",fill:"2",desc:"如：医用、兽用",type:"2",value:[{propName:"医用",value:"0"},{propName:"兽用",value:"1"}]},
        {typeName:"parts",name:"设备部件",fill:"2",desc:"如：整套、机头、机架",type:"2",value:[{propName:"整套",value:"1"},{propName:"机头",value:"2"},{propName:"机架",value:"3"},{propName:"其他",value:"0"}]},
        {typeName:"controlPanel",name:"面板类型",desc:"如：按键、触摸",fill:"2",type:"2",value:[{propName:"按键",value:"1"},{propName:"触摸",value:"2"}]},
        {typeName:"power",name:"功率(KW)",desc:"如：0.8kw、1kw、5kw",fill:"2",type:"2",value:[{propName:"1",value:"1"},{propName:"5",value:"5"},{propName:"10",value:"10"}]},
        {typeName:"speedGovernor",name:"限束器",desc:"如：旋转、不旋转",fill:"2",type:"2",value:[{propName:"旋转",value:"1"},{propName:"不旋转",value:"2"}]},
      ],
    };
  },
  computed: {
    conditionDialogLabel() {
      switch (this.conditionDialogStatus) {
        case "createCondition":
          return "新增属性";
        case "updateCondition":
          return "编辑属性";
        case "createParam":
          return "新增属性值";
        case "updateParam":
          return "编辑属性值";
      }
    },
  },


  created() {
    this.csFileConditionID = this.$route.query.csFileConditionID;
    this.refreshCurrentList();
  },
  methods: {

    fillValueName(item){
      this.conditionModel.fieldValue=item
      if(item!==null && this.valueList!==[]){
        for(const temp of this.valueList){
          if(item===temp.id){
            this.conditionModel.showName=temp.name;
          }
        }
      }
    },
    /**
     * 填充属性名称
     */
    fillProName(item) {
      if (item === null || item === "") {
        this.conditionModel.showName = "";
      } else {
        for (const temp of this.addPropertyList) {
          if (temp.typeName === item) {
            this.conditionModel.showName = temp.name;
            break;
          }
        }
      }
    },

    getPropertyName(name){
       for(const a of this.addPropertyList){
         if(name===a.typeName){
            return a.name;
         }
       }
       return "无";
    },

    /**
     * 回退到上一个路由
     */
    goBack() {
      this.$router.go(-1);
    },
    /**
     * @description: 刷新列表
     * @param {*}
     * @return {*}
     */
    refreshCurrentList() {
      this.getConditionList();
    },
    /**
     * @description: 获取筛选条件列表
     * @param {*}
     * @return {*}
     */
    getConditionList() {
      this.loading = true;
      const params = {
        csFileConditionId: this.csFileConditionID,
      };
      getConditionDetail(params).then((res) => {
        this.tableData = res.data[0].childConditionList;
        if(this.tableData===null||this.tableData===[]){
         this.maxsort=1;
        }
        else{
          for(const temp of this.tableData){
            if (temp.sort>this.maxsort){
              this.maxsort=temp.sort+1;
            }
          }
        }
        this.currentConditionName=res.data[0].showName;
        this.loading = false;
      });
    },

    /**
     * 获取资料类型列表
     */
    getFileCategoryList() {
      let params = {
        sortName: "",
        sortOrder: "asc",
        pageNumber: 1,
        pageSize: 99,
        keyword: "",
        where: "",
      };
      getFileCategoryList(params).then((res) => {
        console.log(res);
        if(res.data.rows!==[]){
          this.valueList=[];
          for(const temp of res.data.rows){
            if (temp.deleteTime === null){
              this.valueList.push({id:temp.csFileTypeID,name:temp.typeName});
            }
          }
          console.log(this.valueList);
        }
      });
    },

    /**
     * 获取所有适用机型
     */
    getMachineSeriesList() {
      let params = {
        sortName: "",
        sortOrder: "",
        pageNumber: 1,
        pageSize: 99,
        keyword: "",
        where: "",
      };
      getMachineSeriesList(params).then((res) => {
        this.machineSeriesList = res.data.rows;
        if(this.machineSeriesList!==[]){
          this.valueList=[]
          for(const temp of this.machineSeriesList){
            this.valueList.push({id:temp.machineSeriesID,name:temp.model+" "+temp.version});

          }
          console.log(this.valueList);
        }
      });
    },



    /**
     * @description: 添加属性，打开对话框
     * @param {*} parentID
     * @param {*} level
     * @return {*}
     */
    handleCreateCondition(parentID, level) {
      console.log(parentID, level);
      this.disableType=false;
      this.showSelectOpt=true;
      this.showProperty=true;
      this.conditionModel = Object.assign({}, defaultModel);
      this.conditionModel.level = level;
      this.conditionModel.parentID = parentID;
      this.conditionModel.userDataType=2;
      this.conditionModel.sort=this.maxsort;
      this.conditionModel.fieldOp="equal";
      this.conditionDialogStatus = "createCondition";
      this.conditionDialogVisible = true;
      this.$nextTick(() => {
        this.$refs["formRef"].clearValidate();
      });
    },

    /**
     * @description: 添加参数值，打开对话框
     */
    handleCreateValue(parentID,parentTypeName,level){
      console.log(parentID,parentTypeName, level);
      this.conditionModel = Object.assign({}, defaultModel);
      this.conditionModel.level = level;
      this.conditionModel.parentID = parentID;
      this.conditionModel.userDataType=2;
      this.conditionModel.fieldName=parentTypeName;
      this.conditionModel.fieldOp="equal";
      this.conditionDialogStatus = "createParam";
      if (parentTypeName !== "") {
        for (const temp of this.addPropertyList) {
          if (temp.typeName === parentTypeName) {
            if (temp.type === "1") {
              this.disableValue=false;
              this.disableOption=true;
              if(parentTypeName==="csFileTypeID"){
                this.getFileCategoryList();
              }
              else if(parentTypeName==="machineSeriesID"){
                this.getMachineSeriesList();
              }
            }
            else{
              this.disableOption=false;
              this.disableValue=true;
            }
          }
        }
      }
      this.showParamSelect=true;
      this.showParamID=true;
      this.showSelectOpt=true;
      this.valueDialogVisible=true;
    },

    /**
     * @description: 更新属性，打开对话框
     * @return {*}
     */
    handleUpdateCondition(row) {
      this.disableType=true;
      this.showSelectOpt=false;
      this.showProperty=false;
      this.conditionModel = { ...row };
      this.conditionDialogStatus = "updateCondition";
      this.conditionDialogVisible = true;
      this.$nextTick(() => {
        this.$refs["formRef"].clearValidate();
      });
    },

    /**
     * @description: 更新参数值，打开对话框
     * @return {*}
     */
    handleUpdateParam(row) {
      this.conditionModel = { ...row };
      if(this.conditionModel.fieldValue!==""){
        this.conditionModel.fieldValue=this.conditionModel.fieldValue-0;
      }
      this.conditionDialogStatus = "updateParam";
      const parentTypeName=row.fieldName;
      if (parentTypeName !== "") {
        for (const temp of this.addPropertyList) {
          if (temp.typeName === parentTypeName) {
            if (temp.type === "1") {
              this.disableValue=false;
              this.disableOption=true;
              if(parentTypeName==="csFileTypeID"){
                this.getFileCategoryList();
              }
              else if(parentTypeName==="machineSeriesID"){
                this.getMachineSeriesList();
              }
            }
            else{
              this.disableOption=false;
              this.disableValue=true;
            }
          }
        }
      }
      this.showParamSelect=false;
      this.showParamID=false;
      this.showSelectOpt=false;
      this.valueDialogVisible=true;
      this.$nextTick(() => {
        this.$refs["formRef"].clearValidate();
      });
    },

    /**
     * 删除属性
     */
    handleRemoveProp(row){
      let params = {
        csFileConditionID: row.csFileConditionID,
      };
      this.$confirm("删除此属性会导致拥有该属性的客服文档无法正常使用，您确定要删除此属性吗？", this.$t("tips"), {
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no"),
        type: "warning",
      })
              .then(() => {
                deleteCondition(params).then(() => {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.refreshCurrentList();
                });
              })
              .catch(() => {
                this.$message("取消操作");
              });
    },

    /**
     * 删除参数值
     */
    handleRemoveParam(row){
      let params = {
          csFileConditionID: row.csFileConditionID,
      };
      this.$confirm("删除此属性值会导致拥有该属性值的客服文档无法正常使用，您确定要删除此属性值吗？", this.$t("tips"), {
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("no"),
          type: "warning",
      })
          .then(() => {
              deleteCondition(params).then(() => {
                  this.$message({
                      message: "操作成功",
                      type: "success",
                  });
                  this.paramDialogVisible=false;
                  this.refreshCurrentList();
              });
          })
          .catch(() => {
              this.$message("取消操作");
          });
     },
    /**
     * @description: 配置参数
     * @param {*} row
     * @return {*}
     */
    handleSetParam(row) {
      this.paramDialogVisible = true;
      this.currentPropertyName=row.showName;
      this.parentID = row.csFileConditionID;
      this.parentFieldName=row.fieldName;
      this.paramsList=[];
      this.paramsList = row.childConditionList.slice(); //父级是定义属性，子集是定义属性下的具体值
      this.$forceUpdate();
    },

    handleParamDialogClose(){
      this.paramDialogVisible = false;
    },
    /**
     * @description: 切换显示状态
     * @param {*} row
     * @return {*}
     */
    toggleShowStatus(row) {
      let params = {
        csFileConditionID: row.csFileConditionID,
        showName: row.showName,
        isEnable: row.isEnable,
      };
      updateCondition(params).then((res) => {
        this.$message({
          message: "修改成功",
          type: "success",
          duration: 1000,
        }).catch((error) => {
          if (row.enable === false) {
            row.enable = true;
          } else {
            row.enable = false;
          }
        });
      });
    },

    addCondition() {
      console.log("jhaja");
      console.log(this.tableData);
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          if(1===this.conditionModel.level){
            if(this.tableData!==null && this.tableData!==[]){
                      for(const temp of this.tableData){
                           if (temp.fieldName === this.conditionModel.fieldName) {
                             this.$notify({
                               title: '温馨提示：',
                               message: '该属性已存在，请勿重复添加！',
                               type: 'warning'
                             });
                             return;
                           }
                           if(temp.showName===this.conditionModel.showName){
                             this.$notify({
                               title: '温馨提示：',
                               message: '已存在同名属性,请修改属性名称！',
                               type: 'warning'
                             });
                             return;
                           }
                        }
              }
            }
            else if(2===this.conditionModel.level) {
              if (this.paramsList!==null && this.paramsList !== []) {
                    console.log("xixi");
                    for (const temp of this.paramsList) {
                          console.log("mama");
                          if (temp.fieldValue === this.conditionModel.fieldValue.toString()) {
                            this.$notify({
                              title: '温馨提示：',
                              message: '参数值已存在，请勿重复添加！',
                              type: 'warning'
                            });
                            return;
                          }
                          if (temp.showName === this.conditionModel.showName) {
                            this.$notify({
                              title: '温馨提示：',
                              message: '参数名已存在，请勿重复输入！',
                              type: 'warning'
                            });
                            return;
                          }
                    }
              }
          }
          const params = Object.assign({}, this.conditionModel);
          addCondition(params).then((res) => {
            this.$notify({
              title: '添加成功',
              type: 'success'
            });
            this.conditionDialogVisible = false;
            this.paramDialogVisible = false;
            this.valueDialogVisible =false;
            this.conditionModel = Object.assign({}, defaultModel);
            this.refreshCurrentList();
          });
        }
      });
    },

    updateCondition() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          console.log(this.conditionModel);
          const params = Object.assign({}, this.conditionModel);
          let param={
            csFileConditionID:params.csFileConditionID,
            showName:params.showName,
            isEnable:params.isEnable,
            showNameRussian:params.showNameRussian,
            sort:params.sort,
          };
          updateCondition(param).then((res) => {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.conditionDialogVisible = false;
            this.paramDialogVisible = false;
            this.valueDialogVisible =false;
            this.conditionModel = Object.assign({}, defaultModel);
            this.refreshCurrentList();
          });
        }
      });
    },
  },
};
</script>

<style>
</style>